import { Box, ChangeEvent, Select, SelectProps, T } from '@veracity/vui'
import { Controller } from 'react-hook-form'

import { getFormValidationMessage } from '@/utils'

import { BaseFormItemProps } from './BaseFormItem'

export interface SelectFormControlProps
  extends Omit<Omit<Omit<SelectProps, 'isMultiple'>, 'children'>, 'label'>,
    BaseFormItemProps {
  w?: number | string
}

export const SelectFormControl = ({
  formControlName,
  control,
  label,
  rules,
  w,
  ...props
}: SelectFormControlProps) => (
  <Controller
    name={formControlName}
    control={control}
    rules={rules}
    render={({ field, fieldState }) => (
      <Box column gap={1} w={w}>
        {!label ? null : <T>{label}</T>}
        <Select
          value={field.value}
          onChange={(ev: ChangeEvent) => {
            field.onChange(ev)
            field.onBlur()
          }}
          isInvalid={!!fieldState.error}
          errorText={getFormValidationMessage(fieldState)}
          showOptionsFilter={props.options && props.options?.length > 15}
          {...props}
        />
      </Box>
    )}
  />
)
